export const getEnviromentUrl =
    window.location.hostname === "localhost"
        ? "https://dev.sara2.hetzner.lfac.dk"
        : "https://" + window.location.hostname;
